import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#697077",
      "fill-rule": "evenodd",
      d: "M8.27 1.398a3.345 3.345 0 0 0-3.344 3.345v1.98H4.81a3.345 3.345 0 0 0-3.345 3.344v5.19A3.345 3.345 0 0 0 4.811 18.6H10a3.345 3.345 0 0 0 3.345-3.344v-.25h1.844a3.345 3.345 0 0 0 3.345-3.345V4.743a3.345 3.345 0 0 0-3.345-3.345H8.27Zm3.575 13.609H8.27a3.345 3.345 0 0 1-3.344-3.345v-3.44H4.81a1.845 1.845 0 0 0-1.845 1.845v5.19c0 1.018.826 1.844 1.845 1.844H10a1.845 1.845 0 0 0 1.845-1.844v-.25ZM6.425 4.743c0-1.019.827-1.845 1.845-1.845h6.92c1.018 0 1.844.826 1.844 1.845v6.919a1.845 1.845 0 0 1-1.845 1.845H8.27a1.845 1.845 0 0 1-1.844-1.845V4.743Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "copy"}) } }